import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { FlagFilledIcon, FlagIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/content-feedback';

type Props = {
  selected: boolean;
  onClick: () => void;
};

const FlagContentButton: React.FC<Props> = ({ selected, onClick }) => {
  return (
    <Button
      variant="ghost"
      size="small"
      aria-haspopup="dialog"
      data-testid="flag-content-button"
      icon={
        selected ? (
          <FlagFilledIcon color="interactive" data-testid="selectedFlagIcon" />
        ) : (
          <FlagIcon color="interactive" data-testid="unselectedFlagIcon" />
        )
      }
      iconPosition="before"
      onClick={onClick}
      aria-label={selected ? _t('Report an issue - Change response') : _t('Report an issue')}
    >
      {_t('Report an issue')}
    </Button>
  );
};

export default FlagContentButton;
